<template>
  <div>
    <Dialog
      :visible.sync="displayModal"
      :modal="true"
      :contentStyle="{ overflow: 'visible' }"
      @hide="closeDialog"
      :closable="false"
    >
      <template #header>
        <span>
          {{ $t("mensajesTOS.titulo") }}
        </span>

        <span class="rightAlign">
          <button
            type="button"
            @click="logout()"
            class="dialog-titlebar-icon dialog-titlebar-close link"
            v-tooltip.bottom="$t('mensajesTOS.cerrarSesion')"
          >
            <span class="dialog-titlebar-close-icon pi pi-sign-out" />
          </button>
        </span>
      </template>

      <div class="grid paddingLR">
        <div class="col-1 verticalAlignBottom">
          <Checkbox v-model="checked" :binary="true" />
        </div>

        <div class="col-10">
          {{ $t("mensajesTOS.pre") }}
          <a :href="CONDICIONES_URL" target="_blank">{{
            $t("mensajesTOS.condicionesGenerales")
          }}</a>
          {{ $t("mensajesTOS.between") }}
          <a :href="POLITICA_PRIVACIDAD_URL" target="_blank">{{
            $t("mensajesTOS.politicaPrivacidad")
          }}</a>
          {{ $t("mensajesTOS.post") }}
        </div>
      </div>

      <template #footer>
        <div class="center">
          <Button
            :label="$t('common.buttons.accept')"
            icon="pi pi-check"
            @click="modificarUsuarioTos()"
            v-tooltip.bottom="
              checked
                ? $i18n.t('mensajesTOS.aceptoCondiciones')
                : $i18n.t('mensajesTOS.aceptaCondiciones')
            "
            autofocus
            :disabled="!checked"
          />
        </div>
      </template>
    </Dialog>

    <Toast />
  </div>
</template>


<script>
import { MODIFICA_USUARIO_TOS } from "@/graphQLQueries/UsuarioQueries";

import { OUTER_URLS } from "@/resources/constants";

export default {
  name: "AceptacionTos",
  props: ["displayConfirmation"],
  data() {
    return {
      displayModal: this.displayConfirmation,
      checked: false,
    };
  },
  created() {
    this.CONDICIONES_URL = OUTER_URLS.CONDICIONES_GENERALES_URL;
    this.POLITICA_PRIVACIDAD_URL = OUTER_URLS.POLITICA_PRIVACIDAD_URL;
  },
  methods: {
    closeDialog() {
      this.displayModal = false;
      this.$emit("close");
    },
    modificarUsuarioTos() {
      this.$apollo
        .mutate({
          mutation: MODIFICA_USUARIO_TOS,
          variables: {
            query: {
              tos: this.checked,
              uuid: this.$store.state.profile.uuid,
              email: this.$store.state.profile.email,
            },
            idioma: this.$i18n.locale,
          },
        })
        .then(() => {
          this.closeDialog();
        })
        .catch((error) => {
          console.error(error);
          this.$toast.add({
            severity: "error",
            summary: this.$t("mensajesTOS.errorActualizacionTosTitulo"),
            detail: this.$t("mensajesTOS.errorActualizacionTos"),
            life: 5000,
          });
        });
    },
    logout() {
      this.$keycloak.logout();
    },
  },
};
</script>


<style lang="scss" scoped>
</style>